import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Nav from "../components/Nav";
import { api } from "../lib/api";
import { toast } from "sonner";
import { StyleTag } from "./Signup";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      toast.error("Passwords don't match");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated. Log in with your new password.");
      nav("/login");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Couldn't reset password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F4F7F6]">
      <Nav />
      <div className="max-w-md mx-auto px-6 py-12">
        <h1 className="font-display text-4xl text-slate-800">Set a new password.</h1>
        <p className="text-slate-600 mt-2">Pick something you'll remember this time.</p>

        {!token ? (
          <div className="mt-8 bg-white rounded-3xl p-8 border border-slate-100 shadow-sm text-center" data-testid="reset-no-token">
            <p className="text-slate-600">This link is missing its reset code. Request a fresh one.</p>
            <Link to="/forgot-password" className="inline-block mt-4 text-[#2E9D96] font-semibold">Request a new link</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-8 bg-white rounded-3xl p-8 border border-slate-100 shadow-sm space-y-5">
            <label className="block">
              <span className="uppercase tracking-[0.15em] text-xs font-semibold text-slate-500">New password</span>
              <input
                type="password"
                required
                minLength={6}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="input zaf-focus mt-2"
                data-testid="reset-password-input"
              />
            </label>
            <label className="block">
              <span className="uppercase tracking-[0.15em] text-xs font-semibold text-slate-500">Confirm password</span>
              <input
                type="password"
                required
                minLength={6}
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                className="input zaf-focus mt-2"
                data-testid="reset-confirm-input"
              />
            </label>
            <button
              data-testid="reset-submit"
              disabled={loading}
              className="w-full bg-[#2E9D96] hover:bg-[#1F7B75] disabled:opacity-60 text-white font-semibold rounded-full py-3 transition-colors"
            >
              {loading ? "Saving…" : "Update password"}
            </button>
          </form>
        )}
      </div>
      <StyleTag />
    </div>
  );
}
